<template>
  <div class="home">
    <div class="intro">
      <h1>Evaluate Your Plate</h1>
      <h2>For the Planet's Sake</h2>
      <p>Chances are you’ve heard a lot about carbon footprints and greenhouse gases. But if you want to drive major change with what’s on your plate, it means looking at the complete picture.</p>

      <p>That’s why our calculator takes six key pillars of sustainability into account to give you the full story of your food’s impact on the planet.</p>

      <p>Choose an option below to get started.</p>
    </div>

    <div class="button-links">
      <router-link class="link link-diet" :to="{ name: 'evaluate-your-plate', params: {region: this.$store.state.Region.region} }">
        <div class="heading">Examine Your Eating</div>
        <p>Take our quick questionnaire to see how your diet stacks up against our six sustainability standards.</p>
        <div class="btn btn--secondary btn--orange">
          Take the Test
          <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 5.49996L0.75 10.2631L0.75 0.736816L6 5.49996Z" fill="#328F4C"/>
          </svg>
        </div>
      </router-link>

      <router-link class="link link-meals" :to="{ name: 'map-your-meal', params: {region: this.$store.state.Region.region} }">
        <div class="heading">Map your meal</div>
        <p>Compare the impacts of your favorite dishes and get your recipe for a healthy planet.</p>
        <div class="btn btn--secondary btn--green">
          View tool
          <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 5.49996L0.75 10.2631L0.75 0.736816L6 5.49996Z" fill="#328F4C"/>
          </svg>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  metaInfo: {
   // if no subcomponents specify a metaInfo.title, this title will be used
   title: 'Evaluate your plate'
  },
  components: {
  },
  mounted() {
    window.location.href = 'https://www.ciwf.com/sustainable-food/evaluate-your-plate'
    this.regionData = this.$route.params.region
    this.$store.commit('Region/SET_REGION', this.regionData)
  },
  data() {
    return {
      regionData: null
    }
  },
  computed: {
    currentPath() {
      return this.$route.name
    },
    regionComputed() {
      return this.$store.state.Region.region
    }
  },
  methods: {
    updateRegion() {
      this.$store.commit('Region/SET_REGION', this.regionData)
    }
  },
  watch: {
    $route(to) {
      this.$store.commit('Region/SET_REGION', to.params.region)
    },
    regionData(newVal) {
      if (newVal != this.$route.params.region) {
        this.$router.push({ name: this.currentPath, params: { region: newVal }})
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../assets/styles/vars';

  .home {
      max-width: 1200px;
      display: flex;
      flex-flow: column;
      margin: 40px auto;
      padding-left: 24px;
      padding-right: 24px;
      h1 {
        font-family: $fSecondary;
        font-weight: $fwMed;
        font-size: 24px;
        line-height: 35px;
        margin-bottom: 4px;
        color: #5A5A5A;
        text-align: center;
      }
      h2 {
        font-family: $fPrimary;
        font-weight: $fwMed;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 38px;
        color: $cBlack;
        text-align: center;
      }
      p {
        text-align: center;
      }
      .intro {
        max-width: 450px;
        display: flex;
        flex-flow: column;
        margin: 0 auto;
      }
      .btn {
        svg {
          margin-left: 8px;
        }
        &--orange {
          color: $cOrange;
          svg {
            path {
              fill: $cOrange;
            }
          }
        }
        &--green {
          color: $cSecondaryGreen;
        }
      }
    .button-links {
      margin-top: 44px;
      display: flex;
      flex-flow: column;

      @media (min-width: 768px) {
        flex-flow: row;
      }
    }
    .link {
      color: $cWhite;
      display: block;
      width: 100%;
      text-decoration: none;
      padding: 70px 27px 50px;
      border-radius: 20px;
      margin-bottom: 24px;
      &:last-of-type {
        margin-right: 0;
      }
      @media (min-width: 768px) {
        margin-right: 24px;
        margin-bottom: 0;
      }
      .heading {
        font-family: $fSecondary;
        font-weight: $fwSemiBold;
        font-size: 28px;
        line-height: 42px;
        text-decoration: none;
        text-transform: uppercase;
        margin-bottom: 12px;
      }
      p {
        font-family: $fPrimary;
        font-weight: $fwMed;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 24px;
        text-align: left;
      }
    }
    .link-diet {
      background: url('../assets/diet-bg.svg') $cOrange;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      order: 1;
      @media (min-width: 768px) {
        order: 0;
      }
    }
    .link-meals {
      background: url('../assets/meal-bg.svg') $cSecondaryGreen;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      order: 0;
      @media (min-width: 768px) {
        order: 1
      }
    }
  }
</style>
